module.exports = __webpack_public_path__ + "static/media/picture-(187).7ea6b6d1.JPG";